

export const errorHandler = {
    // 错误类型消息
    contentPolicy: '内容不符合平台政策，请修改后重试',
    safetyViolation: '内容涉及安全问题，请修改提示词后重试',
    noImageGenerated: '未能生成图片，请尝试修改提示词或重新生成',
    recitationConcern: '内容可能涉及版权问题，请修改提示词后重试',
    promptTooComplex: '提示词过于复杂或包含冲突要求，请简化后重试',
    rateLimit: '请求过于频繁，请稍后重试',
    credits: '积分不足，请充值后重试',
    timeout: '操作超时，请重试',
    network: '网络连接失败，请检查网络连接',
    networkError: '网络连接失败，请检查网络连接',
    server: '服务器内部错误，请稍后重试',
    auth: '身份验证失败，请重新登录',
    notFound: '资源未找到，可能已被删除',
    apiError: 'API调用失败，请稍后重试',
    unknown: '未知错误，请稍后重试',
    
    // Video generation error messages
    videoGenerateRequestFailed: '视频生成请求失败',
    requestFailed: '请求失败',
    generateFailed: '生成失败',
    generateTimeoutInfo: '生成超时，可稍后到“创作记录”中查看结果',
    queryGenerateStatusFailed: '查询生成状态失败',
    
    // HTTP错误消息
    badRequest: '请求参数错误',
    paymentRequired: '需要付费才能继续',
    accessDenied: '访问被拒绝，请检查权限',
    methodNotAllowed: '请求方法不被允许',
    conflict: '请求冲突，资源可能已被修改',
    internalServerError: '服务器内部错误，请稍后重试',
    badGateway: '网关错误，请稍后重试',
    serviceUnavailable: '服务暂时不可用，请稍后重试',
    gatewayTimeout: '网关超时，请稍后重试'
  };
